import React from 'react';

import SelectAllCheckbox from './select_all_checkbox';

import type { Props } from './types';

export default function MapListHeaderLiteCrm({ selectionCount, ...props }: Props) {
  return  (
    <div className="bg-white d-flex border-bottom align-items-center p-3 gap-2">
      <SelectAllCheckbox {...props} />
      <span className="fw-semibold">Property Name / Address </span>
      <span className="text-muted">
        {selectionCount} selected
      </span>
    </div>
  );
}
